export default {
    userInfo: state => {
        return state.userInfo;
    },
    employeeTimeline: state => {
        return state.employeeTimeline;
    },
    isLoggedIn: state => {
        return state.loggedInState;
    },
    countries: state => {
        return state.countries;
    },
    company: state => {
        return state.company;
    },
    companyInfo: state => {
        return state.companyInfo;
    },
    companyTimeline: state => {
        return state.companyTimeline;
    },
    dashboard: state => {
        return state.dashboard;
    },
    calendar: state => {
        return state.calendar;
    },
    locations: state => {
        return state.locations;
    },
    location: state => {
        return state.location;
    },
    departments: state => {
        return state.departments;
    },
    workflows: state => {
        return state.workflows;
    },
    backofficeItems: state => {
        return state.backofficeItems;
    },
    leaveTypes: state => {
        return state.leaveTypes;
    },
    adminLeavePolicies: state => {
        return state.adminLeavePolicies;
    },
    marketplaceOffers: state => {
        return state.marketplaceOffers;
    },
    benefits: state => {
        return state.benefits;
    },
    benefitList: state => {
        return state.benefitList;
    },
    timeOffs: state => {
        return state.timeOffs;
    },
    announcements: state => {
        return state.announcements;
    },
    availableTimeoffs: state => {
        return state.availableTimeoffs;
    },
    myTimeoffs: state => {
        return state.myTimeoffs;
    },
    everything: state => {
        return state.everything;
    },
    empPopUpShown: state => {
        return state.empPopUpShown;
    },
    profileImageURL: state => {
        return state.profile_image_url;
    },
    provider: state => {
        return state.provider;
    },
    providerBenefits: state => {
        return state.providerBenefits;
    },
    me: state => {
        return state.me;
    },
    marketplaceSearch: state => {
        return state.marketplaceSearch
    },
    accessRequests: state =>{
        return state.accessRequests
    }
};